import { gql, useMutation } from '@apollo/client';

export const REGISTER_MUTATION = gql`
  mutation Register($input: RegisterOperatorInput!) {
    register(input: $input) {
      id
    }
  }
`;
export const useRegisterMutation = () => {
  return useMutation(REGISTER_MUTATION);
};
